import { apiClient } from './api-client';
import type { OrganizationFeatureFlag } from '@scrambl/shared';

class FeatureFlagsApi {
  private static instance: FeatureFlagsApi | null = null;

  public static getInstance(): FeatureFlagsApi {
    if (!FeatureFlagsApi.instance) {
      FeatureFlagsApi.instance = new FeatureFlagsApi();
    }
    return FeatureFlagsApi.instance;
  }

  async getOrganizationFlags(): Promise<OrganizationFeatureFlag[]> {
    return apiClient<OrganizationFeatureFlag[]>('/feature-flags/organization');
  }

  async isEnabled(key: string): Promise<{ enabled: boolean }> {
    const params = new URLSearchParams({ key });
    return apiClient<{ enabled: boolean }>(`/feature-flags/check?${params.toString()}`);
  }

  /**
   * Check a GLOBAL rollout flag by key, ignoring per-organization overrides.
   * Works without an organization context (e.g. during onboarding, before the
   * user has an org).
   */
  async checkGlobal(key: string): Promise<{ isEnabled: boolean }> {
    return apiClient<{ isEnabled: boolean }>(
      `/feature-flags/global/${encodeURIComponent(key)}`,
    );
  }

  /**
   * Check multiple feature flags at once - more efficient than individual calls
   */
  async checkBulk(keys: string[]): Promise<Record<string, boolean>> {
    if (keys.length === 0) return {};
    const params = new URLSearchParams({ keys: keys.join(',') });
    return apiClient<Record<string, boolean>>(`/feature-flags/check-bulk?${params.toString()}`);
  }
}

export const featureFlagsApi = FeatureFlagsApi.getInstance();
